import { Modals } from './components';
import { SubscriptionSettingsList } from './components/SubscriptionSettingsList';
import { FiltersContextProvider } from './contexts/FiltersContextProvider';
import { ModalsContextProvider } from './contexts/ModalsContextProvider';
import { QueryContextProvider } from './contexts/QueryContextProvider';
import { Header } from './header';

export const SubscriptionsPage = () => (
  <FiltersContextProvider>
    <QueryContextProvider>
      <ModalsContextProvider>
        <Header />
        <SubscriptionSettingsList />
        <Modals />
      </ModalsContextProvider>
    </QueryContextProvider>
  </FiltersContextProvider>
);
